import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';

import { AbstractWS } from './teaser.service';
import { TeaserComponent } from './teaser';
import { TeaserRangeComponent } from './teaser.components';
import { PopoverInfo } from './teaser.popover';
import { OrderBy, GroupBy } from './teaser.pipes';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		TeaserComponent,
		TeaserRangeComponent,
		PopoverInfo,
		OrderBy,
		GroupBy
	],
	imports: [
		IonicModule,
		TranslateModule.forChild(),
	],
	exports: [
		TeaserComponent,
		OrderBy,
		GroupBy
	],
	entryComponents: [
		PopoverInfo
	],
	providers:[
		AbstractWS
	]
})
export class TeaserComponentModule { }



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.module.ts